import $ from 'jquery'

import { useDocumentUploadStore } from '../../reconciliation/stores/document-upload'
import { documentUiStates } from '../../reconciliation/constants'
import getPiniaInstance from '@app/shared/pinia/instance'
import {
  previewAttachment,
  downloadAttachment,
} from '@app/utils/attachment-helpers'
import { useDrawer } from '@app/shared/pinia/drawer'
import { RightDrawerContent } from '@app/shared/types/drawer'
import { DocumentLinkType } from '@app/shared/types/sf-data'
import { useSidebarFilePreviewStore } from '@app/application/sidebar-file-preview/store/sidebar-file-preview'
import { isUsingTwoDrawerLayout } from '@app/utils/domHelpers'

interface DocumentDataset extends DOMStringMap {
  documentId: string
  documentFileName: string
  documentSize: string
  documentPreviewable: string
}

interface ExternalLinkDataset extends DOMStringMap {
  linkId: string
  linkName: string
  linkUrl: string
}

$(document).on('click', '[data-behaviour~="document-preview-link"]', (e) => {
  const documentId = (e.currentTarget as HTMLElement).dataset
    .documentId as string
  const dataset = (e.currentTarget as HTMLElement).dataset as DocumentDataset

  if (isUsingTwoDrawerLayout() && dataset.documentFileName) {
    const drawerStore = useDrawer(getPiniaInstance())
    const sidebarFilePreviewStore = useSidebarFilePreviewStore(
      getPiniaInstance()
    )

    const isInRightCompare =
      $(e.currentTarget).closest('div.right-compare').length > 0

    sidebarFilePreviewStore.setAttachment({
      name: dataset.documentFileName,
      size: parseInt(dataset.documentSize, 10),
      previewable: dataset.documentPreviewable === 'true',
      document_id: parseInt(documentId, 10),
      linkType: DocumentLinkType.Document,
    })

    if (!isInRightCompare) {
      sidebarFilePreviewStore.syncFilePreviewDrawerUrlParams()
    }

    drawerStore.openDrawer({
      direction: 'right',
      content: RightDrawerContent.FilePreview,
    })
  } else {
    previewAttachment(documentId)
  }
  return false
})

$(document).on('click', '[data-behaviour~="document-download-link"]', (e) => {
  const documentId = (e.currentTarget as HTMLElement).dataset
    .documentId as string
  downloadAttachment(documentId)
  return false
})

$(document).on('click', '[data-behaviour~="document-edit-link"]', (e) => {
  const { linkId, linkName, linkUrl } = (e.currentTarget as HTMLElement)
    .dataset as ExternalLinkDataset

  const documentUploadStore = useDocumentUploadStore(getPiniaInstance())
  documentUploadStore.setExternalLinkAttributes(linkName, linkUrl, linkId)
  documentUploadStore.activateState(documentUiStates.DOCUMENT_LINK)
  return false
})
